/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { deepmerge } from '@adobe-commerce/elsie/lib';
import en_US from '@adobe-commerce/elsie/i18n/en_US.json';

export type Lang = 'en_US';

export const definition = {
  default: en_US,
  en_US,
};

// https://github.com/synacor/preact-i18n
// eslint-disable-next-line no-restricted-imports
export * from 'preact-i18n';

export const getDefinitionByLanguage = (lang: Lang) => {
  return deepmerge(definition.default, definition[lang] || {});
};
